import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';

import { AuthService } from '../services/auth.service';

const ANON_AUTH_PATHS = [
  '/auth/login',
  '/auth/register',
  '/auth/refresh',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/verify-email',
  '/auth/resend-verification'
];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = auth.getAccessToken();
  const tenantId = auth.getTenantId();

  const isAnonAuth = ANON_AUTH_PATHS.some((p) => req.url.includes(p));

  let outgoing = req;
  if (!isAnonAuth && (token || tenantId)) {
    const headers: Record<string, string> = {};
    if (token) headers['Authorization'] = `Bearer ${token}`;
    if (tenantId) headers['X-Tenant-Id'] = tenantId;
    outgoing = req.clone({ setHeaders: headers });
  }

  return next(outgoing).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status !== 401 || isAnonAuth || req.url.includes('/auth/refresh')) {
        return throwError(() => err);
      }

      return auth.refresh().pipe(
        switchMap(() => {
          const retryHeaders: Record<string, string> = {};
          const newToken = auth.getAccessToken();
          const newTenant = auth.getTenantId();
          if (newToken) retryHeaders['Authorization'] = `Bearer ${newToken}`;
          if (newTenant) retryHeaders['X-Tenant-Id'] = newTenant;
          return next(req.clone({ setHeaders: retryHeaders }));
        }),
        catchError((refreshErr) => {
          auth.logout();
          return throwError(() => refreshErr);
        })
      );
    })
  );
};
